/*
 *
 * IMPORTANT: this file should have no dependencies!
 *
 * It is used by react entrypoints (like map.js) that want to stay as small as possible
 */

/**
 * returns "http://localhost:8080" or "https://trevor.io", depending on environment
 */
export function rootDomain() {
  // TODO: couldn't we just use window.location.origin ???
  return `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ''
  }`;
}
